<i [attr.data-feather]="icon" class="{{classes}}"></i>